import axios from "axios";

export async function getOptionsService(uid: string) {
    let serviceResponse: any = null;
    

    const headers = {
        'Authorization': `UserToken ${uid}`,
    }
    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVICE_URL}/benchmark/get/configurations`, { headers });

        if (res.data && res.data.status === 200 && res.data.data) {
            serviceResponse = res.data.data;
            //console.log("Fetched solo options:", serviceResponse);
        } else {
            //console.error("Unexpected response structure:", res.data);
        }
    } catch (error: any) {
        //console.error("Error fetching configurations:", error.message);
        return null;
    }

    return serviceResponse;
}

export async function updateOptionsService(uid: string, updatedData: { 
    id: 'inventory' | 'order' | 'gondolaandcold' | 'promotions' | 'promotionslist', 
    enabled?: boolean, 
    name?: string, 
    requirements?: string[], 
    rolsCanAcces?: string[],
    icon?: string,
    position?: number, 
}) {
    let serviceResponse: any = null;
    const headers = {
        'Authorization': `UserToken ${uid}`,
    };

    try {
        const res = await axios.put(
            `${process.env.REACT_APP_SERVICE_URL}/benchmark/update/configurations`, 
            updatedData, 
            { headers }
        );

        if (res.data && res.data.status === 200) {
            serviceResponse = res.data;
            console.log("Configuraciones actualizadas:", serviceResponse);
        } else {
            console.error("Estructura de respuesta inesperada:", res.data);
        }
    } catch (error: any) {
        console.error("Error al actualizar configuraciones:", error.message);
        return null;
    }

    return serviceResponse;
}

export async function updateGondolaPromotionsService(uid: string, updatedData: { 
    
    
    typeCategory: 'gondolaandcold' | 'promotions', 
    id: string,
    position?: number, 
    name?: string, 
    enabled?: boolean, 
    icon?: string,
    required?: boolean,
}) {
    let serviceResponse: any = null;
    const headers = {
        'Authorization': `UserToken ${uid}`,
    };

    //console.log("En servicio", updatedData);

    try {
        const res = await axios.put(
            `${process.env.REACT_APP_SERVICE_URL}/benchmark/update/configurations/categorys`, 
            updatedData, 
            { headers }
        );

        if (res.data && res.data.status === 200) {
            serviceResponse = res.data;
            //console.log("Configuraciones actualizadas:", serviceResponse);
        } else {
            //console.error("Estructura de respuesta inesperada:", res.data);
        }
    } catch (error: any) {
        //console.error("Error al actualizar configuraciones:", error.message);
        return null;
    }

    return serviceResponse;
}

export async function createGondolaPromotionsService(uid: string, updatedData: { 
    typeCategory: 'gondolaandcold' | 'promotions', 
    id: string,
    position?: number, 
    name?: string, 
    enabled?: boolean, 
    icon?: string,
    required?: boolean,
}) {
    let serviceResponse: any = null;
    const headers = {
        'Authorization': `UserToken ${uid}`,
    };

    //console.log("En servicio", updatedData);

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_SERVICE_URL}/benchmark/create/configurations/categorys`, 
            updatedData, 
            { headers }
        );
        //console.log("Respuesta del servicio:", res.data);
        
        if (res.data && res.data.status === 201) {
            serviceResponse = res.data;
            //console.log("Configuraciones actualizadas:", serviceResponse);
        } else {
            //console.log("Estructura de respuesta inesperada:", res.data);
        }
    } catch (error: any) {
        //console.error("Error al actualizar configuraciones:", error.message);
        return null;
    }

    return serviceResponse;
}
